import { createSelector } from 'reselect';
import authEmployee from 'store/selectors/authEmployee';

const isTeamAdmin = (auth, employee) =>
  auth.isSuperAdmin || employee?.isAdmin || employee?.isTeamAdmin;

export default createSelector(state => state.auth, authEmployee, isTeamAdmin);
